import React from 'react';

import UserLoginsManagement from '../../components/Admin/UserLoginsManagement'

import MainBlockHeader from '../MainBlockHeader'
import MainBlockContainer from '../MainBlockContainer';
import { useTranslation } from 'react-i18next';

export default function UserLoginsPage() {
  const { t } = useTranslation();

  return (
    <>
      <MainBlockHeader header={t('admin.userLoginList.pageTitle')} >
      </MainBlockHeader>

      <MainBlockContainer>
        <UserLoginsManagement />
      </MainBlockContainer>
    </>
  );
}
